export default __webpack_public_path__ + "static/media/Group 18174.28fd5169.png";